import React, { Component } from 'react';
import { calculateExpouser } from '../../util/expouser.util'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID} from '../../configs/const';
let oid = OPERATOR_ID.toLowerCase()
export default class BetForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bid_amount: "",
            buttonValues: [],
            betForm: {}
        };
        this.onChange = this.onChange.bind(this)
        this.changeBid = this.changeBid.bind(this)
        this.bidChange = this.bidChange.bind(this)
    }
    componentDidMount() {
        let configData = JSON.parse(localStorage.getItem("buttonsValues"))
        if (!!configData && configData.length > 0) {
            this.setState({ buttonValues: configData, runner_name: this.props.runner_name })
        }
        if (localStorage.getItem("betForm")) {
            let bf = JSON.parse(localStorage.getItem("betForm"))
            this.setState({ betForm: bf })
            if (!!this.props.updateExpo) {
                let mktBets = []
                if (this.props.curBets) {
                    mktBets = this.props.curBets.filter((bet, i) => {
                        return bet.marketId === this.props.gameCode === '300' ? this.props.eventMarket.catalogue.marketId : this.props.eventMarket.marketId
                    })
                }
                let expo = calculateExpouser(this.props.eventMarket, bf.selectionId, this.props.selcted_bet_option, bf.bid_amount, bf.bid_at, mktBets)
                if (!!localStorage.getItem('betExpo') && localStorage.getItem('betExpo') !== "{}") {
                    this.props.updateExpo(expo)
                }
            }
            if (!!bf.bid_amount) {
                this.setState({ bid_amount: bf.bid_amount })
            }
        }
    }
    componentWillReceiveProps() {
        let configData = JSON.parse(localStorage.getItem("buttonsValues"))
        if (!!configData && configData.length > 0) {
            this.setState({ buttonValues: configData, runner_name: this.props.runner_name })
        }
        if (localStorage.getItem("betForm")) {
            let bf = JSON.parse(localStorage.getItem("betForm"))
            this.setState({ betForm: bf })
            if (!!bf.bid_amount) {
                this.setState({ bid_amount: bf.bid_amount })
            }
        }
    }

    changeBid(val) {
        if (val === "" || val < 0) {
            val = 0
        }
        this.setState({ bid_amount: val }, () => {
            let bf = this.state.betForm
            bf.bid_amount = val
            localStorage.setItem("betForm", JSON.stringify(bf))
            if (!!this.props.updateExpo) {
                let mktBets = []
                if (this.props.curBets) {
                    mktBets = this.props.curBets.filter((bet, i) => {
                        return bet.marketId === this.props.gameCode === '300' ? this.props.eventMarket.catalogue.marketId : this.props.eventMarket.marketId
                    })
                }
                const prfdt = JSON.parse(localStorage.getItem('profData'));
                if(!!prfdt && prfdt.role !== 'DemoClient') {
                    let expo = calculateExpouser(this.props.eventMarket, this.state.betForm.selectionId, this.props.selcted_bet_option, this.state.bid_amount, this.state.betForm.bid_at, mktBets)
                    this.props.updateExpo(expo)
                }
            }
        })
    }
    onChange(e) {
        if (e.target.value.toString().indexOf("-") > -1 || e.target.value === "-" || e.target.value < 0) {
            return false
        }
        this.changeBid(e.target.value)
    }
    bidChange(e) {
        let self = this
        if (e.target.value.toString().indexOf("-") > -1 || e.target.value === "-" || e.target.value < 0) {
            return false
        }
        let betForm = self.state.betForm
        betForm.bid_at = e.target.value
        self.setState({ betForm: betForm }, () => {
            self.changeBid(self.state.bid_amount)
        })
    }
    thexInputClick(val) {
        let cur_amount = this.state.bid_amount.toString()
        let new_amount = ""
        if (val !== "back") {
            new_amount = cur_amount + val.toString()
        } else {
            new_amount = cur_amount.substring(0, cur_amount.length - 1);
        }
        this.changeBid(new_amount)
    }
    addBet() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        if(!!accData && Object.keys(accData).length > 0){
            let currencyConversion = JSON.parse(localStorage.getItem('profData')).currencyConversion;
            let minBid = this.props.gameCode === '300' ? (!!this.props.eventMarket.catalogue ? this.props.eventMarket.catalogue.marketCondition.minBet : this.props.eventMarket.marketCondition.minBet) : this.props.eventMarket.minBet
            minBid = minBid/currencyConversion;
            if (this.state.bid_amount <= 0) {
                this.props.notify("Your bet must be a positive number", "error")
                return false
            }
            // if (this.state.bid_amount < minBid) {
            //     this.props.notify("Your bet must be higher then " + minBid, "error")
            //     return false
            // }
            let maxBid = this.props.gameCode === '300' ? (!!this.props.eventMarket.catalogue ? this.props.eventMarket.catalogue.marketCondition.maxBet : this.props.eventMarket.marketCondition.maxBet) : this.props.eventMarket.maxBet
            maxBid = maxBid/currencyConversion;
            if (this.state.bid_amount < minBid || this.state.bid_amount > maxBid) {
                this.props.notify("Your bet must be between " + minBid + " and " + maxBid, "error")
                return false
            }
            let mtp = this.props.gameCode === '300' ? (!!this.props.eventMarket.catalogue ? this.props.eventMarket.catalogue.marketCondition.mtp : this.props.eventMarket.marketCondition.mtp): this.props.eventMarket.mtp 
            mtp = mtp ? mtp : 5000
            if (this.props.gameCode !== '300' && this.props.bid_at > mtp) {
                this.props.notify("Your bet value must be lower then " + mtp, "error")
                return false
            }
            this.props.addBet({ "bet_amount": this.state.bid_amount, "team": this.props.runner_name, "price": this.props.bid_at, "bet_for": this.props.selcted_bet_option, "market": this.props.eventMarket, "line": !!this.props.bid_line ? this.props.bid_line : (!!this.state.betForm && !!this.state.betForm.bid_line ? this.state.betForm.bid_line : null) })
        } else {
            document.getElementById('btnLoginb2cLogin').click();
        }
    }

    changeBidAt(e, provider, minus=false){
        // debugger
        if (provider === "BETFAIR") 
        {
            let val;
            if(minus)
            {
                val = (parseFloat(this.state.betForm.bid_at) - 0.01).toFixed(2);
            } else {
                val = (parseFloat(this.state.betForm.bid_at) + 0.01).toFixed(2);
            }
            const runnerobj = !!this.props && !!this.props.eventMarket && !!this.props.eventMarket.metadata.book.runners ? this.props.eventMarket.metadata.book.runners.filter(itm => itm.selectionId === this.props.selectionId) : null
            const conval = parseFloat(runnerobj[0][this.props.selcted_bet_option][0].price).toFixed(2)
            if(val > (parseFloat(conval) + 0.05)){//this.props.selcted_bet_option === 'back' && 
                this.props.notify("Your bet cannot be higher then " + (parseFloat(conval) + 0.05).toFixed(2), "error");
                return false;
            } else if(val < (parseFloat(conval) - 0.05)){ //this.props.selcted_bet_option === 'lay' && 
                this.props.notify("Your bet cannot be lower then " + (parseFloat(conval) - 0.05).toFixed(2), "error");
                return false;
            }

            
            e.target.value = val;
            // e.target.value = minus ? (parseFloat(this.state.betForm.bid_at) - 0.01).toFixed(2) : (parseFloat(this.state.betForm.bid_at) + 0.01).toFixed(2); 
            this.bidChange(e); 
        }
    }
    render() {
        let moboleBidData = this.state.betForm.bid_line + " ( " + this.state.betForm.bid_at + " )"
        let lbAmount = !!localStorage.getItem("lastBidAmount") ? localStorage.getItem("lastBidAmount") : 100
        lbAmount = parseInt(lbAmount)
        const marketType = this.props.gameCode === '300' ? (!!this.props.eventMarket.catalogue ? '['+ this.props.eventMarket.displayMarketNameTime[1]+']' : this.props.eventMarket.marketType) : this.props.eventMarket.marketType
        const provider = this.props.gameCode === '300' ? (!!this.props.eventMarket.catalogue ? this.props.eventMarket.catalogue.provider : this.props.eventMarket.provider) : this.props.eventMarket.provider
        return (
            <>
                <tr id="betFormBtns" className={this.props.selcted_bet_option === "back" ? "br-top back-bg-dark placebet-hide-mobile b-t-slip" : "br-top lay-bg-dark placebet-hide-mobile b-t-slip"}>
                    <td colSpan="11" className="w-100">
                        <div className="bt-title float-right" style={{ marginRight: "0px" }}>
                            <span className="bt-slip-title font-weight-bold " style={{ marginLeft: "5px" }}>
                                {this.props.gameCode === '300' ? this.props.eventMarket.displayMarketNameTime[0] : this.state.betForm.runner_name}
                            </span>
                            {!this.state.betForm.bid_line && <span className="bt-slip-title-light  font-weight-bold">
                                {!!this.props.eventMarket && !!marketType ? "- " + marketType.replace("_", " ") : null}
                            </span>}
                            <div className="input-group betslip-group mr-1">
                                <span className="input-group-btn">
                                    <button type="button" onClick={(e) => { this.changeBidAt(e, provider, true) }} className="btn btn-danger btn-number btn-plus-minus minusborder btncolorpm" data-type="minus">
                                        <span className="fa fa-minus"></span>
                                    </button>
                                </span>
                                <input type="text" style={{ MozAppearance: "textfield" }} step="0.01" className="form-control font-weight-bold text-center bet-amt" min={0} onChange={this.bidChange} value={!!this.state.betForm.bid_line ? moboleBidData : this.state.betForm.bid_at} placeholder={!!this.state.betForm.bid_line ? moboleBidData : this.state.betForm.bid_at} id="test" disabled={provider !== "BETFAIR"} />
                                <span className="input-group-btn">
                                    <button type="button" onClick={(e) => { this.changeBidAt(e, provider, false) }} className="btn btn-success btn-number btn-plus-minus plusborder btncolorpm" data-type="plus">
                                        <span className="fa fa-plus"></span>
                                    </button>
                                </span>
                            </div>
                            <div className="input-group betslip-group">
                                <span className="input-group-btn">
                                    <button type="button" onClick={() => { this.changeBid((!!this.state.bid_amount ? parseFloat(this.state.bid_amount) : 0) - lbAmount) }} className="btn btn-danger btn-number btn-plus-minus minusborder btncolorpm" data-type="minus" data-field="quant[2]">
                                        <span className="fa fa-minus"></span>
                                    </button>
                                </span>
                                <input type="number" style={{ MozAppearance: "textfield" }} className="form-control font-weight-bold text-center bet-amt" min={0} onChange={this.onChange} value={this.state.bid_amount} autoFocus={true} placeholder="" id="test" />
                                <span className="input-group-btn">
                                    <button type="button" onClick={() => { this.changeBid((!!this.state.bid_amount ? parseFloat(this.state.bid_amount) : 0) + lbAmount) }} className="btn btn-success btn-number btn-plus-minus plusborder btncolorpm" data-type="plus" data-field="quant[2]">
                                        <span className="fa fa-plus"></span>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr className={this.props.selcted_bet_option === "back" ? "br-top back-bg-light placebet-hide-mobile b-t-slip" : "br-top lay-bg-light placebet-hide-mobile b-t-slip"}>
                    <td colSpan="11" className="w-100">
                        <div className="bt-title float-right " style={{ marginRight: "5px" }}>
                            {this.state.buttonValues.length === 0 ?
                                <div className="bt-title d-inline ">
                                    <span className={this.props.selcted_bet_option === "back" ? "btn-place-bet btn-bid" : "btn-place-bet btn-ask"} onClick={() => { localStorage.setItem("lastBidAmount", 100); this.changeBid(100) }}>100</span>
                                    <span className={this.props.selcted_bet_option === "back" ? "btn-place-bet btn-bid" : "btn-place-bet btn-ask"} onClick={() => { localStorage.setItem("lastBidAmount", 500); this.changeBid(500) }}>500</span>
                                    <span className={this.props.selcted_bet_option === "back" ? "btn-place-bet btn-bid" : "btn-place-bet btn-ask"} onClick={() => { localStorage.setItem("lastBidAmount", 1000); this.changeBid(1000) }}>1000</span>
                                    <span className={this.props.selcted_bet_option === "back" ? "btn-place-bet btn-bid" : "btn-place-bet btn-ask"} onClick={() => { localStorage.setItem("lastBidAmount", 5000); this.changeBid(5000) }}>5000</span>
                                    <span className={this.props.selcted_bet_option === "back" ? "btn-place-bet btn-bid" : "btn-place-bet btn-ask"} onClick={() => { localStorage.setItem("lastBidAmount", 10000); this.changeBid(10000) }}>10000</span>
                                    <span className={this.props.selcted_bet_option === "back" ? "btn-place-bet btn-bid" : "btn-place-bet btn-ask"} onClick={() => { localStorage.setItem("lastBidAmount", 50000); this.changeBid(50000) }}>50000</span>
                                </div> :
                                <div className="bt-title d-inline">
                                    {
                                        this.state.buttonValues.map((btn, i) => {
                                            if (i >= 0 && i < 6) {
                                                return <span className={this.props.selcted_bet_option === "back" ? "btn-place-bet btn-bid" : "btn-place-bet btn-ask"} onClick={() => { localStorage.setItem("lastBidAmount", btn.value); this.changeBid(btn.value) }}>{btn.name}</span>
                                            } else {
                                                return false
                                            }
                                        })
                                    }
                                </div>}
                            <span className="btn-place-bet btn-green" onClick={() => { this.addBet() }}>Place Bet</span>
                            <span onClick={() => { if (!!this.props.updateExpo) { this.props.updateExpo({}) }; this.props.betForm(null, null) }} className="btn-cancel btn-place-cancel">Cancel</span>
                        </div>
                    </td>
                </tr>
                {this.props.loadingBet && <tr className="placebet-hide-mobile">
                    <td colSpan="11" className=""><div className="w-100 placeloaderdesktop placeloader">Placing your bets, Please wait <img alt="" src={BASE_IMAGE_PATH+"/"+oid+"/uimg/l.gif"} /></div></td>
                </tr>}
                <tr id="betFormBtnsMob" className={this.props.selcted_bet_option === "back" ? "br-top b-t-slip-mobile back-bg-dark" : "br-top b-t-slip-mobile lay-bg-dark"} >
                    <td colSpan="11" className="mobile-input">
                        <div className="w-48 mobile-input-plus">
                            <span className="plus-icon" style={{ background: "#a4a4a4", color: "white" }} onClick={(e) => { if (provider === "BETFAIR") { e.target.value = (parseFloat(this.state.betForm.bid_at) - 0.01).toFixed(2); this.bidChange(e) } }}>-</span>
                            <span><input type="text" className="form-control" onChange={this.bidChange} value={!!this.state.betForm.bid_line ? moboleBidData : this.state.betForm.bid_at} placeholder={!!this.state.betForm.bid_line ? moboleBidData : this.state.betForm.bid_at} id="test" disabled={provider !== "BETFAIR"} /></span>
                            <span className="minus-icon" style={{ background: "#a4a4a4", color: "white" }} onClick={(e) => { if (provider === "BETFAIR") { e.target.value = (parseFloat(this.state.betForm.bid_at) + 0.01).toFixed(2); this.bidChange(e) } }}>+</span>
                        </div>
                        <div className="w-48 mobile-input-plus float-right pr-2">
                            <span className="plus-icon" style={{ background: "#a4a4a4", color: "white" }} onClick={() => { this.changeBid(parseFloat(this.state.bid_amount) - lbAmount) }}>-</span>
                            <span><input type="number" className="form-control" onChange={this.onChange} value={parseFloat(this.state.bid_amount)} min={0} placeholder="" id="test" disabled={false} /></span>
                            <span className="minus-icon" style={{ background: "#a4a4a4", color: "white" }} onClick={() => { this.changeBid(!!this.state.bid_amount ? parseFloat(this.state.bid_amount) + lbAmount : lbAmount) }}>+</span>
                        </div>
                    </td>
                </tr>
                <tr className={this.props.selcted_bet_option === "back" ? "br-top b-t-slip-mobile dark-tab-blue " : "br-top b-t-slip-mobile dark-tab-red"} >
                    <td colSpan="11" className="mt-1 mb-1 p-0">
                        {this.state.buttonValues.length === 0 ?
                            <div className="w-100 mbet-slip">
                                <div className={this.props.selcted_bet_option === "back" ? "w-20 text-center d-inline pad-font " : "w-20 text-center d-inline pad-font1 "} onClick={() => { localStorage.setItem("lastBidAmount", 100); this.changeBid(100) }}>100</div>
                                <div className={this.props.selcted_bet_option === "back" ? "w-20 text-center d-inline pad-font " : "w-20 text-center d-inline pad-font1 "} onClick={() => { localStorage.setItem("lastBidAmount", 500); this.changeBid(500) }}>500</div>
                                <div className={this.props.selcted_bet_option === "back" ? "w-20 text-center d-inline pad-font " : "w-20 text-center d-inline pad-font1 "} onClick={() => { localStorage.setItem("lastBidAmount", 1000); this.changeBid(1000) }}>1000</div>
                                <div className={this.props.selcted_bet_option === "back" ? "w-20 text-center d-inline pad-font " : "w-20 text-center d-inline pad-font1 "} onClick={() => { localStorage.setItem("lastBidAmount", 5000); this.changeBid(5000) }}>5000</div>
                                <div className={this.props.selcted_bet_option === "back" ? "w-20 text-center d-inline pad-font " : "w-20 text-center d-inline pad-font1 "} onClick={() => { localStorage.setItem("lastBidAmount", 10000); this.changeBid(10000) }}>10000</div>
                                <div className={this.props.selcted_bet_option === "back" ? "w-20 text-center d-inline pad-font " : "w-20 text-center d-inline pad-font1 "} onClick={() => { localStorage.setItem("lastBidAmount", 50000); this.changeBid(50000) }}>50000</div>
                            </div> :
                            <div className="w-100 mbet-slip">
                                {
                                    this.state.buttonValues.map((btn, i) => {
                                        if (i >= 0 && i < 6) {
                                            return <div className="w-20 text-center d-inline pad-font " onClick={() => { localStorage.setItem("lastBidAmount", btn.value); this.changeBid(btn.value) }}>{btn.name}</div>
                                        } else {
                                            return false
                                        }
                                    })
                                }
                            </div>}
                    </td>
                </tr>
                <tr className="br-top b-t-slip-mobile bg-white" >
                    <td colSpan="11" className="mt-1 mb-1 p-0">
                        <table className="w-100 text-black w-100 font-weight-bold br-1-bl" >
                            <tr className="br-bottom">
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(1) }}><span>1</span></td>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(2) }}><span>2</span></td>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(3) }}><span>3</span></td>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(4) }}><span>4</span></td>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(5) }}><span>5</span></td>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(6) }}><span>6</span></td>
                                <td rowspan="2" className="w-14" onClick={() => { this.thexInputClick("back") }}>
                                    <span><img alt="" src={BASE_IMAGE_PATH+"/"+oid+"/uimg/bt-icon.jpg"} /></span>
                                </td>
                            </tr>
                            <tr>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(7) }}><span>7</span></td>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(8) }}><span>8</span></td>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(9) }}><span>9</span></td>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(0) }}><span>0</span></td>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick("00") }}><span>00</span></td>
                                <td className="br-right w-14" onClick={() => { this.thexInputClick(".") }}><span>.</span></td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr className="br-top b-t-slip-mobile bg-white" >
                    <td colSpan="11" className="mt-1 mb-1">
                        <div className="w-100 text-center d-inline-block">
                            <div className="w-48  mr-1"><span onClick={() => { if (!!this.props.updateExpo) { this.props.updateExpo({}) }; this.props.betForm(null, null); }} className="cancel-bt-bet btn-place-cancel">Cancel</span></div>
                            <div className="w-48"><span onClick={() => { this.addBet() }} className="place-bt-bet text-white btn-green" >Place Bet</span></div>
                        </div>

                    </td>
                </tr>
                {this.props.loadingBet && <tr className="b-t-slip-mobile">
                    <td colSpan="2" className="w-100 height30 placeloadermobile placeloader">Placing your bets, Please wait <img alt="" src={BASE_IMAGE_PATH+"/"+oid+"/uimg/l.gif"} /></td>
                </tr>}
            </>
        )
    }
}
